import { Navigate } from "react-router-dom";

export const PublicRoute = ({ children }) => {
  const auth = localStorage.getItem("auth");
  const token = localStorage.getItem("token");

  if (auth && token) return <Navigate to="/home" />;
  return children;
};

export const PrivateRoute = ({ children }) => {
  const auth = localStorage.getItem("auth");
  const token = localStorage.getItem("token");

  if (!auth && !token) return <Navigate to="/" />;
  return children;
};

export const rupiahFormat = (value) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency", // add Rp
    currency: "IDR",
    // maximumSignificantDigits: 20
    minimumFractionDigits: 0,
  }).format(value || 0);

export const trxIdGenerator = () => {
  const rndInt = Math.floor(Math.random() * 99999) + 1;
  return rndInt;
};

export const sendWhatsAppMe = (waNumber, text) => {
  if (waNumber[0] === "6") {
    const numSplit = waNumber.split("");
    numSplit[0] = "";
    numSplit[1] = "0";
    const correctNumber = numSplit.join("");
    window.open(`https://wa.me/+62${correctNumber}${text}`, "_blank");
  } else {
    window.open(`https://wa.me/+62${waNumber}${text}`, "_blank");
  }
};

export const generateImageFallback = (text) => {
  const words = (text || "").trim().split(/\s+/);
  const initial =
    words.length > 1
      ? (words[0][0] + words[1][0]).toUpperCase()
      : (words[0][0] || "?").toUpperCase();
  const svg = `<svg width="200" height="200" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="200" fill="#ffffff"/><text x="100" y="100" font-size="50" font-family="Montserrat, sans-serif" font-weight="bold" text-anchor="middle" dy=".3em" fill="#d3d3d3">${initial}</text></svg>`;
  return `data:image/svg+xml;base64,${btoa(svg)}`;
};
